import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useCallback } from 'react';
export var useItem = function useItem(props) {
  var uid = props.uid,
      handleRemoveItem = props.handleRemoveItem;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDeleting = _useState2[0],
      setIsDeleting = _useState2[1];

  var removeItem = useCallback(function () {
    setIsDeleting(true);
    handleRemoveItem(uid);
  }, [handleRemoveItem, uid]);
  return {
    isDeleting: isDeleting,
    removeItem: removeItem
  };
};